import { render } from "./DetailPaket.vue?vue&type=template&id=4c844afc"
import script from "./DetailPaket.vue?vue&type=script&lang=js"
export * from "./DetailPaket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__